module.exports = __webpack_public_path__ + "img/foot_code_3.5e9d5dcd.png";